import CryptoJS from 'crypto-js';
/**
 * DES 操作
 * @description
 * 加密解密
 */
export const crypto = {
  encryptByMD5(strMessage) {
    if (!strMessage) return;
    return CryptoJS.MD5(strMessage).toString();
  },
  encryptByDES(strMessage, key) {
    key = key || 'greatmap';
    if (!strMessage) {
      return '';
    }
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.DES.encrypt(strMessage, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  },
  decryptByDES(strMessage, key) {
    key = key || 'greatmap';
    if (!strMessage) {
      return '';
    }
    let keyHex = CryptoJS.enc.Utf8.parse(key);
    let decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(strMessage),
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  },
  /**
   * AES加密（返回Base64编码字符串）
   * @param {string} data - 要加密的原始字符串
   * @param {string} pass - 密码（将自动补全/截断为16字节）
   * @returns {string} Base64编码的加密结果
   */
  encryptAES(data, pass) {
    // 补全/截断密钥为16字节
    const keyBytes = this.padKey(CryptoJS.enc.Utf8.parse(pass), 16);
    const ivBytes = CryptoJS.lib.WordArray.create(keyBytes.words.slice(0, 4)); // 取前16字节作为IV

    // 加密
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(data),
      keyBytes,
      {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return encrypted.toString();
  },
  /**
   * AES解密（输入Base64编码字符串）
   * @param {string} data - Base64编码的加密数据
   * @param {string} pass - 密码（将自动补全/截断为16字节）
   * @returns {string} 解密后的原始字符串
   */
  decryptAES(data, pass) {
    // 补全/截断密钥为16字节
    const keyBytes = this.padKey(CryptoJS.enc.Utf8.parse(pass), 16);
    const ivBytes = CryptoJS.lib.WordArray.create(keyBytes.words.slice(0, 4)); // 取前16字节作为IV

    // 解密
    const decrypted = CryptoJS.AES.decrypt(
      data,
      keyBytes,
      {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  },

  /**
   * 密钥长度补全（如果不足则填充0，如果过长则截断）
   * @param {CryptoJS.lib.WordArray} key - 原始密钥
   * @param {number} length - 目标长度（字节）
   * @returns {CryptoJS.lib.WordArray} 处理后的密钥
   */
  padKey(key, length) {
    // 转换为字节数组
    let keyBytes = key.toString(CryptoJS.enc.Hex);
    let paddedBytes = [];

    // 填充或截断
    for (let i = 0; i < length; i++) {
      if (i * 2 < keyBytes.length) {
        paddedBytes.push(parseInt(keyBytes.substr(i * 2, 2), 16));
      } else {
        paddedBytes.push(0); // 不足部分填充0
      }
    }

    // 转换回WordArray
    const hexString = paddedBytes.map(b => b.toString(16).padStart(2, '0')).join('');
    return CryptoJS.enc.Hex.parse(hexString);
  }
};
